
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/search-price",
      function () {
        return require("private-next-pages/search-price/index.tsx");
      }
    ]);
  